/**
 * PATH: src/pages/pricing/PaymentFailure.jsx
 * PURPOSE: Display failure state when payment does not go through
 * UI: Material UI
 */

import React from "react";
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function PaymentFailure() {
  const navigate = useNavigate();

  return (
    <Box p={4} maxWidth="600px" mx="auto">
      <Card
        elevation={4}
        sx={{ borderRadius: 3, textAlign: "center", py: 4, border: "1px solid #e57373" }}
      >
        <CardContent>
          <Typography variant="h4" fontWeight={700} color="error.main">
            Payment Failed
          </Typography>

          <Typography variant="body1" mt={2} mb={4}>
            Something went wrong. Please try again or contact support.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            sx={{ borderRadius: 2, mr: 2 }}
            onClick={() => navigate("/pricing")}
          >
            Back to Pricing
          </Button>

          <Button
            variant="outlined"
            color="error"
            sx={{ borderRadius: 2 }}
            onClick={() => navigate("/pricing/checkout")}
          >
            Retry Payment
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
